import React, { useEffect, useState } from "react";
import styles from "./ThanksAppMain.module.css";
import { Link, useHistory } from "react-router-dom";

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";
import changeDetails from "../../../store/Actions/DetailsAction";

function ThanksAppMain(props) {
  const history = useHistory();

  useEffect(() => {
    if (props.passportDetails.application === false) {
      history.push("/dashboard/my-applications");
    } else {
      setId(props.passportDetails.id)
      props.ChangePassportDetails({
        application: false,
      });
      props.ChangeDetails({
        total: 0,
        embassy_fees: 0,
        normal_fees: 0,
        express_fees: 0,
      });
    }
  }, []);

  const [id, setId] = useState("")

  return (
    <div>
      <h2 className={styles.head}>
        {" "}
        Thank you! Your application has been
        <br />
        successfully submitted.
      </h2>
      <p className={styles.des}>
        We have received your application and assigned it to your visa officer
        for review.
        <br />
        If we need any other information, we shall call or email you.
      </p>
      <div className={styles.btnCont}>
     <Link to={`/dashboard/my-applications/${id}/review-submitted-application`}>
        <button className={styles.btn1}>Review Application</button>
        {/* <button className={styles.btn1}>Edit Application</button> */}
        </Link>
        <Link to="/dashboard/home">
          <button className={styles.btn2}>Continue</button>
        </Link>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
  details: state.Details.details,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) =>
    dispatch(changePassportDetails(passportDetails)),
  ChangeDetails: (details) => dispatch(changeDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProp)(ThanksAppMain);
